import React from "react";
import { useQuickSightNetworking  } from "@/hooks/useNetworkingReports";

const QuickSightAwsNetworkingDashboard = () => {
  const { embedUrl } = useQuickSightNetworking ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsNetworkingDashboard;
